import { SET_SELECTED_STEP, ADD_TIMELINE } from './types';

const setTimeline = (id, nodes, selectedStep) => ({
  type: ADD_TIMELINE,
  payload: {
    id,
    nodes,
    selectedStep
  }
});

const setSelectedStep = (id, step) => ({
  type: SET_SELECTED_STEP,
  payload: {
    id,
    selectedStep: step
  }
});

export { setTimeline, setSelectedStep };



// WEBPACK FOOTER //
// ./src/store/Timeline/actions.js